import { EmptyObject, ShoppingCart } from 'app/types/common-types'
import { StoreState } from 'app/state/types'

interface StateWithCart extends StoreState {
    cart?: ShoppingCart | EmptyObject
}

export default function isPaymentRequired(state: StateWithCart) {
    const { cart } = state

    return typeof cart?.x_paymentRequired !== 'undefined' ? cart?.x_paymentRequired : undefined
}
